import Vue from 'vue'
import isPresent from 'is-present'

const saveReg = async (registration, params, session) => {
  if (registration.id)
    return (await Vue.axios.patch(apiUpdateUrl(registration, session), { registration: params })).data
  else
    return (await Vue.axios.post(apiCreateUrl(registration, session), { registration: params })).data
}


const fetchExisting = async (id, org_id, include) => {
  return (await Vue.axios.get(
    `/api2/auto/registrations/${id}`,
    { params: { include: include, organization_id: org_id } }
  )).data.object
}


// Checking if RFB has any info in it.
const hasAttrSet = (rfb, registration) => {
  if (rfb.form_block?.form_part?.style === "ConcernsComments") return false

  for (const attr of (rfb.form_block || { attrs: [] }).attrs) {
    if (rfb.entity_attrs[attr] !== '' && rfb.entity_attrs[attr] !== null && rfb.entity_attrs[attr] !== undefined) return true
  }
  if (rfb.has_changed) return true

  for (const id in rfb.custom_attrs) {
    if (rfb.custom_attrs[id] && !id.endsWith("_custom_field")) {
      if (rfb.id && !isPresent(rfb.custom_attrs[id])) return true // Edit, and RFB already exists. We need to be able to delete values in custom fields - ticket 31141
      for (const val of rfb.custom_attrs[id]) {
        const presence = (isPresent(val) || (rfb.form_block?.form_part?.style === "ConcernsComments" && val === "")) //&& rfb.entity_id

        // needed when second parent not selected but custom fields are
        if (presence && rfb.form_block && rfb.form_block.form_part.style === 'Parent' && !rfb.entity_id) {
          const main_rfb = rfb.form_block.form_part.main_form_block()
          if (!registration.find_rblock(main_rfb).entity_id) return false
        }

        return presence
      }
    }
  }

  return false
}


function apiCreateUrl(_reg, session) {
  return scope_path(`/programs/${session.program_id}/registrations`, session)
}
function apiUpdateUrl(reg, session) {
  if (session.curr_org_id) {
    return scope_path(`/programs/${session.program_id}/registrations/${reg.id}`, session)
  } else {
    return `/registrations/${reg.id}`
  }
}

function scope_path(path, session) {
  if (session.curr_org_id) {
    return `/organizations/${session.curr_org_id}${path}`
  } else {
    return path
  }
}

export { saveReg, fetchExisting, hasAttrSet }